import React, {Component} from 'react';
import VenueRepository from "../classes/VenueRepository";
import FilterCheckbox from "./FilterCheckbox";

class FilterCheckboxes extends Component {
  constructor(props) {
    super(props);
    this.state = {filters: null};

    this.venueRepository = new VenueRepository();
    this.venueRepository.getCheckboxField(props.fieldName).then((results) => {
      this.setState({
        filters: results
      });
    });

  }
  render() {
    let fieldName = this.props.fieldName;
    let filterCheckboxes = null;
    if (this.state.filters) {
      filterCheckboxes = [];
      Object.keys(this.state.filters).forEach((filter_index) => filterCheckboxes.push(<FilterCheckbox form={this.props.form} onFilter={this.props.onFilter} filter={this.state.filters[filter_index]} fieldName={fieldName}/>));
    }

    return (
        <fieldset className="fieldgroup fieldgroup--filter form-composite js-form-item form-item js-form-wrapper form-wrapper">
            <legend>
            <span className={"fieldset-legend icon-"+this.props.title.toLowerCase()}>{this.props.title}</span>
            </legend>
            <div className="fieldset-wrapper">
                {filterCheckboxes}
            </div>
        </fieldset>
    );
  }
}

export default FilterCheckboxes;
